class Point {
    constructor(index,  x, y, maxiumHeight){
        this.x = x;
        this.y = y;
        this.fixedY = y;
        this.speed = 0.01;
        this.cur = index;
        this.max = Math.random() * maxiumHeight + 0;
    }

    update(maxiumHeight){
        this.cur += this.speed;
        this.y = this.fixedY + (Math.sin(this.cur) * this.max);
    }

}

export default Point;



// WEBPACK FOOTER //
// ./src/layout/art/point.js